export default __webpack_public_path__ + "static/media/mfarequest.50fa58aa.svg";